"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RivalryTeamIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const LeaderboardContext_1 = require("../Context/LeaderboardContext");
const rivalryConfigUtils_1 = require("../Functions/rivalryConfigUtils");
const RivalryTeamIndicator = ({ rivalryTeam }) => {
    const { factor, eventData } = (0, LeaderboardContext_1.useLeaderboardContext)();
    const color = (0, react_1.useMemo)(() => {
        const rivalry = (0, rivalryConfigUtils_1.resolveRivalryConfig)(eventData);
        return (0, rivalryConfigUtils_1.getRivalryTeamColor)(rivalryTeam, rivalry);
    }, [eventData, rivalryTeam]);
    if (!color)
        return null;
    const size = 8 * factor;
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "span", title: rivalryTeam ?? undefined, "aria-hidden": true, sx: {
            display: 'inline-block',
            width: size,
            height: size,
            minWidth: size,
            borderRadius: '50%',
            backgroundColor: color,
            flexShrink: 0,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.12)',
        } }));
};
exports.RivalryTeamIndicator = RivalryTeamIndicator;
